import { AnyAction, MiddlewareAPI } from 'redux';
import { ThunkDispatch } from 'store/store';
import { isAppSettingsSymbologyChange } from './actions';
import State from 'store/State';
import Services from 'store/Services';

export const appSettingsMiddleware = (services: Services) => [
    updateOrdersStreamOnSymbologyChangedMiddleware(services),
];

export function updateOrdersStreamOnSymbologyChangedMiddleware(
    services: Services
) {
    const { loggingService, ordersStreamingService } = services;

    return (middlewareAPI: MiddlewareAPI<ThunkDispatch<AnyAction>, State>) =>
        (next: ThunkDispatch<AnyAction>) =>
        (action: AnyAction) => {
            const prevState = middlewareAPI.getState();

            // update the state
            next(action);

            const nextState = middlewareAPI.getState();

            if (!isAppSettingsSymbologyChange(prevState, nextState)) {
                return true;
            }

            loggingService.debug(
                'store|updateOrdersStreamOnSymbologyChangedMiddleware',
                `Starting/Updating orders stream`,
                action
            );

            ordersStreamingService.startOrUpdateOrdersStream();
        };
}
